import React from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

const AlertPopup: React.FC<{ message: string; onConfirm: () => void }> = ({
  message,
  onConfirm,
}) => {
  const showAlert = () => {
    MySwal.fire({
      text: message,
      icon: "warning",
      confirmButtonText: "OK",
      confirmButtonColor: "#DF2020",
    }).then((result) => {
      if (result.isConfirmed) {
        onConfirm();
      }
    });
  };

  React.useEffect(() => {
    if (message) {
      showAlert();
    }
  }, [message]);

  return null;
};

export default AlertPopup;
